
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import DateFilterContainer from "@/components/filters/DateFilterContainer.vue";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import PostingsMultiselect from "@/components/autocompleteMultiselects/PostingsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import GroupLocationsMultiselect from "@/components/autocompleteMultiselects/GroupLocationsMultiselectNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";

import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";
import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";

import groupsFiltersTemplate from "@/data/filtersTemplates/groupsFiltersTemplate";

import DropdownOption from "@/entities/DropdownOption";
import Roles from "@/entities/Roles";
import GroupsFiltersQuery from "@/entities/filters/GroupsFiltersQuery";

@Component({
  components: {
    UiButton,
    InputRangeFilter,
    FiltersContainer,
    DateFilterContainer,
    ContractorsMultiselect,
    ManagersMultiselect,
    UiButtonMessage,
    GroupLocationsMultiselect,
    PostingsMultiselect,
    SkillsMultiselect,
    FormGroup,
    UIButton,
    RadioButtonGroup,
  },
})
export default class GroupCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: String, required: true }) readonly userRole!: string;
  @Prop({ type: String, required: true }) readonly userId!: string;
  @Prop({ type: String, default: undefined }) readonly managerId?: string;
  @Prop({ type: Array, default: () => [] })
  readonly managerAccessContractorsIds!: any[];
  @Prop({ type: String, required: true }) companyId!: string;
  @Prop({ type: Object, required: true }) readonly filters!: GroupsFiltersQuery;

  title: string = "";
  locations: DropdownOption[] = [];
  skillsIds: number[] = [];
  postings: DropdownOption[] = [];
  contractorsIds: string[] = [];
  managersIds: string[] = [];
  postingStatus: string = groupsFiltersTemplate.postingStatus;

  get contractorsWhere(): object {
    return getContractorsMultiselectConditions(this.userRole);
  }

  get postingsWhere(): object {
    if (this.userRole == Roles.ADMIN) {
      return {
        manager_id: {
          _is_null: false,
        },
      };
    }
    if (this.userRole == Roles.MANAGER) {
      return {
        applications: {
          user: {
            contracts: {
              id: {
                _in: this.managerAccessContractorsIds,
              },
            },
          },
        },
      };
    }
    return {};
  }


  get locationsNames(): string[] {
    return this.locations.map((location) => location.name);
  }

  get postingsIds(): string[] {
    return this.postings.map((posting) => posting.name);
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.title,
      this.postingStatus,
      this.contractorsIds,
      this.locationsNames,
      this.managersIds,
      this.postingsIds,
      this.skillsIds,
    ]);
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.title = this.filters.title;
    this.locations = getMultiselectValues(this.filters.locations);
    this.skillsIds = this.filters.skills;
    this.postings = getMultiselectValues(this.filters.postings);
    this.contractorsIds = this.filters.contractors;
    this.managersIds = this.filters.managers;
    this.postingStatus = this.filters.postingStatus;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      title: this.title,
      postingStatus: this.postingStatus,
      locations: this.locationsNames,
      skills: this.skillsIds,
      postings: this.postingsIds,
      contractors: this.contractorsIds,
      managers: this.managersIds,
    });
  }

  handleReset(): void {
    this.$emit("filtersReset");
  }
}
